import BaseServiceCrud from './BaseServiceCrud';

export default class EventLogService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'eventLog';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            locale: criteria?.locale,
            event_type: criteria?.eventType?.enumValue,
            ip_address: criteria.ipAddress,
            user_name: criteria.userName,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    get(eventLogId) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/${eventLogId}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
